import { ReactNode } from 'react';

import { IconsEnum } from '../../../../../../assets/icons/types';
import { Translate } from '../../../../../../helpers/Translate';
import { words } from '../../../../../../locales/keys';
import { DisplaySettingsMenuItem } from '../DisplaySettingsMenuItem';

interface DisplaySettingsMainPanelProps {
  showDimensions: boolean;
  onToggleDimensions: () => void;
  unitsLabel: ReactNode;
  onOpenUnits: () => void;
}

function DisplaySettingsMainPanel({
  showDimensions,
  onToggleDimensions,
  unitsLabel,
  onOpenUnits
}: DisplaySettingsMainPanelProps) {
  return (
    <div className="flex flex-col w-full">
      <DisplaySettingsMenuItem
        icon={IconsEnum.DIMENSIONS_SOLID}
        label={<Translate id={words.showDimensions} />}
        toggle
        checked={showDimensions}
        onClick={onToggleDimensions}
      />
      <DisplaySettingsMenuItem
        icon={IconsEnum.UNITS_METRIC_CM_SOLID}
        label={<Translate id={words.changeUnits} />}
        currentValue={unitsLabel}
        withChevron
        onClick={onOpenUnits}
      />
    </div>
  );
}

export default DisplaySettingsMainPanel;
